import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { Strings } from "../../Stores/StringsStore";

@observer
export class RotateClockwiseButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.rotateClockwiseButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M24.56,21.65A10.26,10.26,0,1,1,22.84,8.38L19.5,11.16l9.67,2.25L28.7,3.52l-3.13,2.6A13.75,13.75,0,1,0,27.3,23.84Z" />
				</svg>
			</i>
		</Button>;
	}
}
